import * as React from 'react';
import CampaignEditorModal from '../../components/marketing/CampaignEditorModal';
import { CampaignEditorContext, CampaignEditorPayload } from './context';

// Single mount for the campaign editor. Consumers call `open(...)` (via
// useCampaignEditor) instead of mounting their own <CampaignEditorModal/>,
// so at most one editor lives on the tree per provider.
export function CampaignEditorProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [state, setState] = React.useState<CampaignEditorPayload | null>(null);

  const value = React.useMemo(() => ({ open: setState }), []);

  return (
    <CampaignEditorContext.Provider value={value}>
      {children}
      {state ? (
        <CampaignEditorModal
          isOpen
          onClose={() => setState(null)}
          campaign={state.campaign}
          offboardingContext={state.offboardingContext}
        />
      ) : null}
    </CampaignEditorContext.Provider>
  );
}
